import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    borderRadius: 15,
    overflow: 'hidden',
    padding: [4, 8],
  },
  green: {
    backgroundColor: theme.palette.colors.sprouta,
  },
  red: {
    backgroundColor: theme.palette.colors.champagne,
  },
  blue: {
    backgroundColor: theme.palette.colors.linkWater,
  },
}));



// WEBPACK FOOTER //
// ./src/sharedComponents/Tag/useStyles.js